'use strict';

var _ = require('lodash');
var PercentFormatterController = function PercentFormatterController($scope, $filter) {
  var rmPercent = $filter('rmPercent');
  $scope.parser = function (value) {
    if (_.isNil(value)) {
      return value;
    }
    return parseFloat(value) / 100;
  };
  $scope.formatter = function (value) {
    return rmPercent(value);
  };
};
PercentFormatterController.$inject = ['$scope', '$filter'];
module.exports = PercentFormatterController;